import PropTypes from 'prop-types';
// material
import { Box } from '@mui/material';
import { useSelector } from 'react-redux';
import useAuth from 'hooks/useAuth';

// ----------------------------------------------------------------------

Logo.propTypes = {
  sx: PropTypes.object
};

export default function Logo({ sx }) {
  const { user } = useAuth();

  // const { businessSelected = {} } = useSelector((state) => state.business);
  return <Box component="img" src="/static/servicepluglogo.svg" sx={{ width: '100%', ...sx }} />;
}
